import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CarouselImageApiService } from './services/api/carousel-image.api.service';
import { CarouselImageModel } from './models/carousel-image';
import { environment } from '@env/environment';

declare var bootstrap: any;

@Component({
  selector: 'app-hero',
  standalone: true,
  imports: [],
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.css'],
})
export class HeroComponent implements OnInit {
  carouselImages: CarouselImageModel[] = [];
  isLoading = true;
  apiBaseUrl = environment.apiBaseUrl;

  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: Object,
    private readonly carouselImageService: CarouselImageApiService,
  ) {}

  ngOnInit(): void {
    this.loadCarouselImages();
  }

  private loadCarouselImages(): void {
    this.carouselImageService.getActiveImages().subscribe({
      next: (images) => {
        // Se o servidor retornou sucesso mas sem imagens, usa fallback
        if (!images || images.length === 0) {
          this.isLoading = false;
          this.loadFallbackImages();
          return;
        }

        this.carouselImages = images;
        this.isLoading = false;

        // Aguarda o Angular atualizar o DOM antes de inicializar o carrossel
        if (isPlatformBrowser(this.platformId)) {
          requestAnimationFrame(() => {
            setTimeout(() => this.initializeCarousel(), 100);
          });
        }
      },
      error: (error) => {
        this.isLoading = false;
        this.loadFallbackImages();
      },
    });
  }

  private loadFallbackImages(): void {
    // Imagens de fallback caso a API falhe
    this.carouselImages = [
      {
        id: 1,
        title: 'Imagem 1',
        description: null,
        imagePath: 'assets/image/fundo.png',
        order: 1,
        active: true,
        creationDate: '',
        updateDate: '',
        userNameCreate: '',
        userNameUpdate: '',
      },
      {
        id: 2,
        title: 'Imagem 2',
        description: null,
        imagePath: 'assets/image/fundo2.png',
        order: 2,
        active: true,
        creationDate: '',
        updateDate: '',
        userNameCreate: '',
        userNameUpdate: '',
      },
      {
        id: 3,
        title: 'Imagem 3',
        description: null,
        imagePath: 'assets/image/fundo3.png',
        order: 3,
        active: true,
        creationDate: '',
        updateDate: '',
        userNameCreate: '',
        userNameUpdate: '',
      },
    ];

    if (isPlatformBrowser(this.platformId)) {
      requestAnimationFrame(() => {
        setTimeout(() => this.initializeCarousel(), 100);
      });
    }
  }

  private initializeCarousel(): void {
    const carouselElement = document.querySelector('#heroCarousel');

    if (carouselElement && bootstrap !== undefined) {
      // Destrói instância anterior se existir
      const existingCarousel = bootstrap.Carousel.getInstance(carouselElement);
      if (existingCarousel) {
        existingCarousel.dispose();
      }

      // Verifica quantos slides existem e só inicializa se houver
      const totalSlides =
        carouselElement.querySelectorAll('.carousel-item').length;

      if (totalSlides > 0) {
        const carousel = new bootstrap.Carousel(carouselElement, {
          interval: 5000,
          ride: 'carousel',
          pause: false,
        });
        carousel.cycle();
      }
    }
  }

  getImageUrl(imagePath: string): string {
    // Se a imagem começa com 'uploads/', é da API
    if (imagePath.startsWith('uploads/')) {
      const fullUrl = `${this.apiBaseUrl}/${imagePath}`;
      return fullUrl;
    }
    // Caso contrário, é uma imagem local
    return imagePath;
  }
}
